import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const BalanceTransactionDataSchema_ = z.object({
  _id: zExt.objectId().nullish(),
  date: z.date(),
  amount: z.string(),
  orderNames: z.array(z.string()).nullish(),
  batchName: z.string().nullish(),
  description: z.string(),
  justification: z.string().nullish(),
  balanceSnapshot: z.string().nullish(),
  transactionType: z.string().nullish(),
  fulfillmentGroupId: z.string().nullish(),
  disputeId: z.string().nullish(),
});

export const BalanceTransactionDataSchema: z.ZodType<BalanceTransactionData> =
  BalanceTransactionDataSchema_;
export interface BalanceTransactionData extends z.infer<
  typeof BalanceTransactionDataSchema_
> {}
